export default {
    video_wakingCamera: 'Waking up camera...',
    video_stopingCamera: 'Finishing streaming...',
    video_stoppedCamera: 'Streaming finished',
    video_errorApi: 'The video could not be loaded, please try again',
    video_snapshotErrorApi: 'The snapshot could not be loaded, please try again',
    video_retryMessage: 'The video could not be loaded, either because the server or network failed, please try again.',
    video_cameraOffline: 'The camera is offline',
    video_360Message: 'Please use your mouse drag and drop the video',
    video_errorAccessDenied: 'The video could not be loaded, access denied',
    video_timeout: 'Live video has timed out.',
    video_unableToLiveStream: 'The vehicle is currently offline - unable to live stream',
    video_uploading: "Loading live photos...",
    video_firmwareNotSupport: "Feature not supported",
    video_sdCardError: "SD card error",
    video_failed: "There is not clip available in the selected time range. Try again",
    video_downloadingClip: "Downloading clip...",
    video_privatecliprequest: "Private Clip Request",
    video_privatecliprequest_tooltip:
      "If you check this, the video will only be visible to you.",
  }